module.exports = __webpack_public_path__ + "img/icon4@2x.444aa91a.png";